<template>
	<div class="container">
    <cashgift-item 
      v-for="(item, index) in registerItems" 
      :key="index" 
      :item="item">                
    </cashgift-item>
	</div>
</template>

<script>
import CashgiftItem from './CashgiftItem'
import { cashgiftList,registerCashgiftList } from '../../../api/cashgift'
export default {
	components: {
		CashgiftItem,
	},
	data() {
		return {			
			currentIndex: 0,
			tabs: [
				{
					id: 1,
					title: '未使用'
				},
				{
					id: 2,
					title: '已使用'
        },
        {
					id: 3,
					title: '已过期'
				},
			],
      isLoaded: false,
      registerIsLoaded: false,
      page: 1,
      registerPage:1,    
      items: [],  
      registerItems: [],    
      registerIsMore: 0,
      isMore: 0
		}
	},
	created() {	
		this.loadFirstPageData()	
	},
	methods: {
		goBack() {
			this.$router.go(-1)
		},
		loadFirstPageData() {
      this.loadPageData(true);
    },
    loadMorePageData() {
      this.loadPageData(false);
    },
    loadPageData(isFirstPage) {
      let page = 1
      if (isFirstPage) {
        page = 1        
      } else {
        page = this.page + 1    
      }
      let per_page = 10
      registerCashgiftList('', '', 0).then(res => {         
        if (res && res.cashgifts) {          
          this.registerItems = res.cashgifts  
        }
      }, error => {         
      })            
    },
		onIndexChange(index) {
      this.currentIndex = index
      this.loadFirstPageData()
    },
    loadMore() {  
      if (this.isMore) {
        this.loadMorePageData()
      }          
    }
	},	
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  position: relative;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	background-color:rgb(255, 0, 0);
}
.header {
	@include header;
	border-bottom: 1px solid $lineColor;
}
.topList {
  position: fixed;
  width: 100%;
	margin-top: 44px;	
  height: 40px;		
  z-index: 100;
}
.list-wrapper { 
  margin-top: 92px;
}
</style>


// WEBPACK FOOTER //
// src/page/profile/child/CashgiftList.vue